import { cancelEmployee, confirmEmployee, createEmployee, deleteEmployee, editEmployee } from '@entities/employee/api'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { App } from 'antd'

export const useEmployees = (channelId?: number) => {
    const { message } = App.useApp()
    const queryClient = useQueryClient()

    const createEmployeeMutation = useMutation({
        mutationFn: createEmployee,
        onSuccess: () => message.success('Приглашение сотруднику отправлено')
    })

    const editEmployeeMutation = useMutation({
        mutationFn: editEmployee,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['channelDetails', channelId] })
            message.success('Права сотрудника изменены')
        }
    })

    const deleteEmployeeMutation = useMutation({
        mutationFn: deleteEmployee,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['channelDetails', channelId] })
            message.success('Сотрудник удален')
        }
    })

    const confirmEmployeeMutation = useMutation({
        mutationFn: confirmEmployee,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['channels'] })
            message.success('Приглашение принято')
        }
    })

    const cancelEmployeeMutation = useMutation({
        mutationFn: cancelEmployee,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['channels'] })
            message.success('Приглашение отклонено')
        }
    })

    return {
        actions: {
            createEmployee: createEmployeeMutation.mutate,
            editEmployee: editEmployeeMutation.mutate,
            deleteEmployee: deleteEmployeeMutation.mutate,
            confirmEmployee: confirmEmployeeMutation.mutate,
            cancelEmployee: cancelEmployeeMutation.mutate
        }
    }
}
